export const getOgdTeamColorById = (teamId) => {
  switch (teamId) {
    case 62: // Ventas Squad
      return { color: '#166534', bgColor: '#dcfce7' }; // green

    case 63: // Goal Setters
      return { color: '#1e40af', bgColor: '#dbeafe' }; // blue

    case 64: // Deal Maestros
      return { color: '#6b21a8', bgColor: '#f3e8ff' }; // purple

    case 65: // Chaser Crew
      return { color: '#92400e', bgColor: '#fef3c7' }; // amber

    case 66: // ECPC
      return { color: '#155e75', bgColor: '#cffafe' }; // cyan

    case 67: // Manager
      return { color: '#9f1239', bgColor: '#ffe4e6' }; // rose

    case 110: // Quality Wing
      return { color: '#065f46', bgColor: '#d1fae5' }; // emerald

    case 115: // Edex
      return { color: '#7c2d12', bgColor: '#ffedd5' }; // orange

    default:
      return { color: '#3730a3', bgColor: '#e0e7ff' }; // indigo
  }
};



export const convertToPoperdateTime = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);

  if (isNaN(date)) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours === 0 ? 12 : hours;

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
};